import * as CandidateJobMatchCardReportModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-report-modal.html';
import * as CandidateJobMatchCardScreeningModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-screening-modal.html';
import * as CandidateJobMatchCardImageProctoringInfoModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-image-proctoring-info-modal.html';
import * as CandidateJobMatchCardAssessmentInfoModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-assessment-info-modal.html';
import * as CandidateJobMatchCardMeetingsModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-meetings-modal.html';
import * as CandidateActivityModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidates/candidateCard/candidate-activities-modal.html';
import * as CandidateJobMatchCardNotInterestedModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-not-interested-modal.html';
import * as CandidateJobMatchCardReleasedModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-released-modal.html';
import * as CandidateJobMatchCardDeleteModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-delete-modal.html';
import * as CandidateJobMatchCardNotesModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-notes-modal.html';
import * as CandidateJobMatchCardCommunicationModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-communication-modal.html';
import * as CandidateJobMatchCardAssignRecruiterModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-assign-recruiter-modal.html';
import * as CandidateJobMatchCardMoveModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-move-modal.html';
import * as CandidateJobMatchCardSendAssessmentModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-send-assessment-modal.html';
import * as CandidateJobMatchCardCancelAssessmentModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-cancel-assessment-modal.html';
import * as CandidateJobMatchCardScheduleModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-schedule-modal.html';
import * as CandidateJobMatchCardCancelMeetingModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-cancel-meeting-modal.html';
import * as CandidateJobMatchCardUpdateContactModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-update-contact-modal.html';
import * as CandidateJobMatchCardActionsModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-actions-modal.html';
import * as CandidateJobMatchCardUploadResumeModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-upload-resume-modal.html';
import * as SendAssessmentConfirmResendModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/send-assessment-confirm-resend-modal.html';
export class JobMatchActionsService {
    /*@ngInject*/
    constructor($uibModal, $timeout, StorageService, assessmentService, alertsAndNotificationsService, $state) {
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.StorageService = StorageService;
        this.assessmentService = assessmentService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.$state = $state;
    }
    getReport(jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId, context) {
        let ctrl = this;
        // if(_.isNull(reportUrl)) {
        //     this._showAssessmentReportNotGeneratedWarning();
        // } else {
        if (context == 'job-candidates-compare') {
            $(".modal").addClass("job-candidates-compare-modal-extra-large");
        }
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardReportModal.default,
            backdrop: 'static',
            windowClass: 'four-dot-five-modal-large',
            controller: ['$uibModalInstance', 'assessmentType', 'jobMatchId', 'isSectionalReport', 'testInvitationId', function ($uibModalInstance, assessmentType, jobMatchId, isSectionalReport, testInvitationId) {
                    var vm = this;
                    vm.jobMatchId = jobMatchId;
                    vm.assessmentType = assessmentType;
                    vm.isSectionalReport = isSectionalReport;
                    vm.testInvitationId = testInvitationId;
                    vm.modalTitle = 'Technical Assessment Report';
                    vm.context = "candidateJobMatchCard";
                    if (assessmentType == 'Value') {
                        vm.modalTitle = 'Value Assessment Report';
                    }
                    vm.closeModal = () => {
                        $uibModalInstance.dismiss('close');
                        if (context == 'job-candidates-compare') {
                            ctrl.$timeout(() => {
                                $(".modal").removeClass("job-candidates-compare-modal-extra-large");
                            }, 600);
                        }
                    };
                }],
            controllerAs: 'reportModal',
            size: 'lg',
            resolve: {
                assessmentType: () => {
                    return assessmentType;
                },
                jobMatchId: () => {
                    return jobMatchId;
                },
                isSectionalReport: () => {
                    return isSectionalReport;
                },
                testInvitationId: () => {
                    return testInvitationId;
                }
            }
        });
        // }
    }
    openFeedbackModal(feedbackDetails) {
        let vm = this;
        $(".modal").addClass("job-candidates-compare-modal-extra-large");
        let templateUrl = CandidateJobMatchCardScreeningModal.default;
        let callbackType = 'refreshWorkflow';
        let windowTopClass = 'four-dot-five-modal-medium';
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: templateUrl,
            backdrop: 'static',
            keyboard: false,
            windowTopClass: windowTopClass,
            controller: ['$uibModalInstance', 'jobId', 'jobMatchId', 'candidateId', 'feedbackType', 'label', 'context', function ($uibModalInstance, jobId, jobMatchId, candidateId, feedbackType, label, context) {
                    var ctrl = this;
                    ctrl.jobMatchId = jobMatchId;
                    ctrl.jobId = jobId;
                    ctrl.candidateId = candidateId;
                    ctrl.feedbackType = feedbackType;
                    ctrl.label = label;
                    ctrl.context = context;
                    ctrl.closeModal = () => {
                        ctrl.closeModalAndRefresh();
                    };
                    ctrl.closeModalAndRefresh = () => {
                        $uibModalInstance.close('cancel');
                        vm.$timeout(() => {
                            $(".modal").removeClass("job-candidates-compare-modal-extra-large");
                        }, 600);
                    };
                    ctrl.saveCallback = () => {
                        ctrl.closeModalAndRefresh();
                    };
                }],
            controllerAs: 'jobMatchIdModal',
            size: 'lg',
            resolve: {
                jobId: () => {
                    return feedbackDetails.jobId;
                },
                jobMatchId: () => {
                    return feedbackDetails.jobMatchId;
                },
                label: () => {
                    return feedbackDetails.label;
                },
                candidateId: () => {
                    return feedbackDetails.candidateId;
                },
                feedbackType: () => {
                    return feedbackDetails.feedbackType; //Screening/PhoneScreen/Interview
                },
                context: () => {
                    return feedbackDetails.context;
                }
            }
        });
    }
    _showAssessmentReportNotGeneratedWarning() {
        let message = "The report is currently being generated. You will be notified once the report is available.";
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Report generation in progress!</strong></div>",
            message: message,
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }
        });
    }
    openImageProctoringInfoModal(activeViolation, techAssessmentReportInfoList) {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardImageProctoringInfoModal.default,
            backdrop: 'static',
            keyboard: false,
            bindToController: true,
            windowTopClass: 'four-dot-five-modal-medium',
            controller: ['$uibModalInstance', 'techAssessmentReportInfoList', 'activeViolation', function ($uibModalInstance, techAssessmentReportInfoList, activeViolation) {
                    var vm = this;
                    vm.activeViolation = activeViolation;
                    vm.techAssessmentReportInfoList = techAssessmentReportInfoList;
                    vm.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'imageProctoringInfoModal',
            size: 'lg',
            resolve: {
                activeViolation: () => {
                    return activeViolation;
                },
                techAssessmentReportInfoList: () => {
                    return techAssessmentReportInfoList;
                }
            }
        });
    }
    openAssessmentInfoModal(jobMatchId, assessmentType) {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardAssessmentInfoModal.default,
            backdrop: 'static',
            keyboard: false,
            bindToController: true,
            windowTopClass: 'four-dot-five-modal-extra-large',
            controller: ['$uibModalInstance', 'jobMatchId', 'assessmentType', function ($uibModalInstance, jobMatchId, assessmentType) {
                    var vm = this;
                    vm.jobMatchId = jobMatchId;
                    vm.assessmentType = assessmentType;
                    vm.title = 'Technical Assessment Info';
                    if (vm.assessmentType == 'Value Assessment') {
                        vm.title = 'Value Assessment Info';
                    }
                    vm.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'assessmentInfoModal',
            size: 'lg',
            resolve: {
                jobMatchId: () => {
                    return jobMatchId;
                },
                assessmentType: () => {
                    return assessmentType;
                }
            }
        });
    }
    openMeetingsModal(jobMatchId, meetingType, refreshCallback) {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardMeetingsModal.default,
            backdrop: 'static',
            keyboard: false,
            bindToController: true,
            windowTopClass: 'four-dot-five-modal-large',
            controller: ['$uibModalInstance', 'jobMatchId', 'meetingType', function ($uibModalInstance, jobMatchId, meetingType) {
                    var vm = this;
                    vm.jobMatchId = jobMatchId;
                    vm.meetingType = meetingType;
                    vm.title = 'Interviews';
                    if (vm.meetingType == 'PhoneScreen') {
                        vm.title = 'Phone Screens';
                    }
                    vm.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                    vm.saveCallback = () => {
                        refreshCallback();
                    };
                }],
            controllerAs: 'jobMatchMeetingsModal',
            size: 'lg',
            resolve: {
                jobMatchId: () => {
                    return jobMatchId;
                },
                meetingType: () => {
                    return meetingType;
                }
            }
        });
    }
    showAllActivityModal(jobMatch, jobMatchId, activityMap) {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateActivityModal.default,
            windowClass: 'candidate-activities-modal-window',
            backdrop: 'static',
            controller: ['$uibModalInstance', 'candidateInfo', 'jobMatchId', 'activityMap', function ($uibModalInstance, candidateInfo, jobMatchId, activityMap) {
                    let vm = this;
                    vm.candidateInfo = candidateInfo;
                    vm.jobMatchId = jobMatchId;
                    vm.activityMap = activityMap;
                    vm.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'activityModal',
            size: 'lg',
            resolve: {
                candidateInfo: () => {
                    return jobMatch;
                },
                jobMatchId: () => {
                    return jobMatchId;
                },
                activityMap: () => {
                    return activityMap;
                }
            }
        });
    }
    performAction(context, actionObject, jobMatch, refreshCallback, removeOrRefreshCardCallback) {
        if (!actionObject.allowed) {
            var message = _.isNull(actionObject.message) ? 'This Action is not allowed.' : actionObject.message;
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Action Not Allowed!</strong></div>",
                message: message,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else {
            let actionType = actionObject.actionType;
            let label = actionObject.action;
            switch (actionType) {
                case 'NOT_INTERESTED':
                case 'RELEASE':
                case 'DELETE_JOBMATCH':
                    this._launchSetStatusModal(context, actionObject, label, jobMatch, refreshCallback, removeOrRefreshCardCallback);
                    break;
                case 'START_SCREENING':
                // this._openConferenceScreen(context, actionType, label, jobMatch, refreshCallback, removeOrRefreshCardCallback);
                // break;
                case 'NOTES':
                case 'COMMUNICATION':
                case 'PEER_COMMUNICATION':
                case 'PHONE_SCREEN_FEEDBACK':
                case 'INTERVIEW_FEEDBACK':
                case 'PHONE_SCREEN_FEEDBACK_FROM_MEETING_POPUP':
                case 'INTERVIEW_FEEDBACK_FROM_MEETING_POPUP':
                case 'MOVE_BACKWARD':
                case 'MOVE_FORWARD':
                case 'ASSIGN_RECRUITER':
                case 'SEND_TECHNICAL_ASSESSMENT':
                case 'SEND_VALUE_ASSESSMENT':
                case 'RE_SEND_TECHNICAL_ASSESSMENT':
                case 'RE_SEND_VALUE_ASSESSMENT':
                case 'CANCEL_TECHNICAL_ASSESSMENT':
                case 'CANCEL_VALUE_ASSESSMENT':
                case 'SCHEDULE_PHONE_SCREEN':
                case 'MODIFY_PHONE_SCREEN':
                case 'SCHEDULE_INTERVIEW':
                case 'MODIFY_INTERVIEW':
                case 'CANCEL_PHONE_SCREEN':
                case 'CANCEL_INTERVIEW':
                case 'UPDATE_CONTACT':
                case 'CANDIDATE_JOB_COMPARE':
                case 'CANDIDATE_PROFILE':
                case 'SKIP_RECRUITER_SCREENING':
                case 'SKIP_TECHNICAL_ASSESSMENT':
                case 'SKIP_VALUE_ASSESSMENT':
                case 'SKIP_PHONE_SCREEN':
                case 'SKIP_INTERVIEW':
                case 'EXPORT_CANDIDATE_INFO':
                case 'UPLOAD_RESUME':
                case 'CANDIDATE_BOOKLET':
                case 'SEND_EMAIL':
                case 'CLIENT_REVIEW':
                    this.setDataAndLaunchJobMatchIdModal(context, actionType, label, jobMatch, actionObject, refreshCallback, removeOrRefreshCardCallback);
                    break;
                default:
                //do nothing
            }
        }
    }
    _openConferenceScreen(context, actionType, label, jobMatch, refreshCallback, removeOrRefreshCardCallback) {
        switch (actionType) {
            case 'START_SCREENING':
                let absUrl = this.StorageService.get('baseurl') + '/#/conference?jm=' + jobMatch.jobMatchId + '&ws=rs&m=PHONE';
                window.open(absUrl, '_blank');
                break;
        }
    }
    _launchSetStatusModal(context, actionObject, modalType, jobMatch, refreshCallback, removeOrRefreshCardCallback) {
        let templateUrl = '';
        let statusType = '';
        let windowTopClass = 'four-dot-five-modal-large';
        switch (modalType) {
            case 'Not Interested':
                templateUrl = CandidateJobMatchCardNotInterestedModal.default;
                statusType = 'Not Interested';
                break;
            case 'Release':
                templateUrl = CandidateJobMatchCardReleasedModal.default;
                statusType = 'Release';
                break;
            case 'Delete Job Match':
                templateUrl = CandidateJobMatchCardDeleteModal.default;
                statusType = 'Delete Job Match';
                break;
        }
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: templateUrl,
            backdrop: 'static',
            keyboard: false,
            windowTopClass: windowTopClass,
            controller: ['$uibModalInstance', 'jobMatchDetailsArray', 'statusType', 'workflowStepName', 'formalizeActivityPayload', function ($uibModalInstance, jobMatchDetailsArray, statusType, workflowStepName, formalizeActivityPayload) {
                    var vm = this;
                    vm.jobMatchDetailsArray = jobMatchDetailsArray;
                    vm.statusType = statusType;
                    vm.workflowStepName = workflowStepName;
                    vm.formalizeActivityPayload = formalizeActivityPayload;
                    vm.saveCallback = () => {
                        $uibModalInstance.close('cancel');
                        vm.refreshCallback();
                    };
                    vm.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                    vm.refreshCallback = () => {
                        if (statusType == 'Delete Job Match' && context == "candidateJobMatches") {
                            removeOrRefreshCardCallback();
                        }
                        else {
                            refreshCallback();
                        }
                    };
                }],
            controllerAs: 'setStatusModal',
            size: 'lg',
            resolve: {
                jobMatchDetailsArray: () => {
                    var tempArray = [];
                    var tempObject = {};
                    tempObject.jobMatchId = jobMatch.jobMatchId;
                    tempObject.candidateId = jobMatch.id;
                    tempObject.workflowStepName = jobMatch.currentStep;
                    tempArray.push(tempObject);
                    return tempArray;
                },
                statusType: () => {
                    return statusType;
                },
                workflowStepName: () => {
                    return jobMatch.currentStep;
                },
                formalizeActivityPayload: () => {
                    return actionObject.formalizeActivityPayload;
                }
            }
        });
    }
    setDataAndLaunchJobMatchIdModal(context, modalType, label, jobMatch, actionObject, refreshCallback, removeOrRefreshCardCallback) {
        let templateUrl = '';
        let callbackType = '';
        let windowTopClass = 'four-dot-five-modal-medium';
        switch (modalType) {
            case 'NOTES':
                templateUrl = CandidateJobMatchCardNotesModal.default;
                break;
            case 'COMMUNICATION':
                templateUrl = CandidateJobMatchCardCommunicationModal.default;
                break;
            case 'PEER_COMMUNICATION':
                templateUrl = CandidateJobMatchCardCommunicationModal.default;
                windowTopClass = 'four-dot-five-modal-extra-large';
                callbackType = 'refreshJobMatch';
                break;
            case 'ASSIGN_RECRUITER':
                templateUrl = CandidateJobMatchCardAssignRecruiterModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'START_SCREENING':
                templateUrl = CandidateJobMatchCardScreeningModal.default;
                callbackType = 'refreshWorkflow';
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'PHONE_SCREEN_FEEDBACK':
            case 'INTERVIEW_FEEDBACK':
            case 'PHONE_SCREEN_FEEDBACK_FROM_MEETING_POPUP':
            case 'INTERVIEW_FEEDBACK_FROM_MEETING_POPUP':
                templateUrl = CandidateJobMatchCardScreeningModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'MOVE_FORWARD':
            case 'MOVE_BACKWARD':
                templateUrl = CandidateJobMatchCardMoveModal.default;
                callbackType = 'refreshWorkflow';
                break;
            case 'SEND_TECHNICAL_ASSESSMENT':
            case 'SEND_VALUE_ASSESSMENT':
            case 'RE_SEND_TECHNICAL_ASSESSMENT':
            case 'RE_SEND_VALUE_ASSESSMENT':
                templateUrl = CandidateJobMatchCardSendAssessmentModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'CANCEL_TECHNICAL_ASSESSMENT':
            case 'CANCEL_VALUE_ASSESSMENT':
                templateUrl = CandidateJobMatchCardCancelAssessmentModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'SCHEDULE_PHONE_SCREEN':
            case 'MODIFY_PHONE_SCREEN':
            case 'SCHEDULE_INTERVIEW':
            case 'MODIFY_INTERVIEW':
                templateUrl = CandidateJobMatchCardScheduleModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'CANCEL_PHONE_SCREEN':
            case 'CANCEL_INTERVIEW':
                templateUrl = CandidateJobMatchCardCancelMeetingModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'UPDATE_CONTACT':
                templateUrl = CandidateJobMatchCardUpdateContactModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'CANDIDATE_JOB_COMPARE':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'CANDIDATE_PROFILE':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'CANDIDATE_BOOKLET':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'EXPORT_CANDIDATE_INFO':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                break;
            case 'SKIP_RECRUITER_SCREENING':
            case 'SKIP_TECHNICAL_ASSESSMENT':
            case 'SKIP_VALUE_ASSESSMENT':
            case 'SKIP_PHONE_SCREEN':
            case 'SKIP_INTERVIEW':
                templateUrl = CandidateJobMatchCardMoveModal.default;
                windowTopClass = 'four-dot-five-modal-small';
                callbackType = 'refreshWorkflow';
                break;
            case 'UPLOAD_RESUME':
                templateUrl = CandidateJobMatchCardUploadResumeModal.default;
                windowTopClass = 'four-dot-five-modal-large';
                callbackType = 'refreshJobMatch';
                break;
            case 'SEND_EMAIL':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                windowTopClass = 'four-dot-five-modal-extra-large';
                callbackType = 'refreshJobMatch';
                break;
            case 'CLIENT_REVIEW':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                windowTopClass = 'four-dot-five-modal-large';
                callbackType = 'refreshJobMatch';
                break;
        }
        if (modalType == 'RE_SEND_TECHNICAL_ASSESSMENT' || modalType == 'RE_SEND_VALUE_ASSESSMENT') {
            this._setAssessmentDataAndLaunchModal(context, modalType, label, templateUrl, windowTopClass, callbackType, jobMatch, refreshCallback, removeOrRefreshCardCallback, actionObject);
        }
        else {
            this.launchActionModal(context, jobMatch, modalType, label, templateUrl, windowTopClass, actionObject, callbackType, refreshCallback, removeOrRefreshCardCallback);
        }
    }
    _setAssessmentDataAndLaunchModal(context, modalType, label, templateUrl, windowTopClass, callbackType, jobMatch, refreshCallback, removeOrRefreshCardCallback, actionObject) {
        let assessmentType = 'Technical';
        if (modalType == 'RE_SEND_VALUE_ASSESSMENT') {
            assessmentType = 'Value';
        }
        let assessmentDetailsObject = {};
        let assessmentDetails = {};
        assessmentDetailsObject.jobMatchId = jobMatch.jobMatchId;
        assessmentDetailsObject.assessmentType = assessmentType;
        this.assessmentService.getCandidateAssessmentDetails(assessmentDetailsObject, (data) => {
            assessmentDetails = data;
            assessmentDetails.isSendAssessmentFailed = jobMatch.jobMatchCurrentState.includes("Failed");
            if (!_.isNull(assessmentDetails.expiredDateTime)) {
                assessmentDetails.expiredDateTime = new Date(assessmentDetails.expiredDateTime);
            }
            if (!_.isNull(assessmentDetails.cancelledDateTime)) {
                assessmentDetails.cancelledDateTime = new Date(assessmentDetails.cancelledDateTime);
            }
            if (!_.isNull(assessmentDetails.completedDateTime)) {
                assessmentDetails.completedDateTime = new Date(assessmentDetails.completedDateTime);
            }
            if (!_.isNull(assessmentDetails.sentDateTime)) {
                assessmentDetails.sentDateTime = new Date(assessmentDetails.sentDateTime);
            }
            if (!_.isNull(assessmentDetails.suspendedDateTime)) {
                assessmentDetails.suspendedDateTime = new Date(assessmentDetails.suspendedDateTime);
            }
            if (!_.isNull(assessmentDetails.terminatedDateTime)) {
                assessmentDetails.terminatedDateTime = new Date(assessmentDetails.terminatedDateTime);
            }
            if (!_.isNull(assessmentDetails.testLeftDateTime)) {
                assessmentDetails.testLeftDateTime = new Date(assessmentDetails.testLeftDateTime);
            }
            if (!_.isNull(assessmentDetails.sentDateTime)) {
                assessmentDetails.sentDateTime = new Date(assessmentDetails.sentDateTime);
            }
            var previousStateDateTime = '';
            if (assessmentDetails.assessmentLinkStatus == 'Expired' && !_.isNull(assessmentDetails.expiredDateTime)) {
                previousStateDateTime = assessmentDetails.expiredDateTime;
            }
            else if (assessmentDetails.assessmentLinkStatus == 'Suspended' && !_.isNull(assessmentDetails.suspendedDateTime)) {
                previousStateDateTime = assessmentDetails.suspendedDateTime;
            }
            else if (assessmentDetails.assessmentLinkStatus == 'Terminated' && !_.isNull(assessmentDetails.terminatedDateTime)) {
                previousStateDateTime = assessmentDetails.terminatedDateTime;
            }
            else if (assessmentDetails.assessmentLinkStatus == 'Test Left' && !_.isNull(assessmentDetails.testLeftDateTime)) {
                previousStateDateTime = assessmentDetails.testLeftDateTime;
            }
            else if (assessmentDetails.assessmentLinkStatus == 'Complete' && !_.isNull(assessmentDetails.completedDateTime)) {
                previousStateDateTime = assessmentDetails.completedDateTime;
            }
            else {
                previousStateDateTime = assessmentDetails.sentDateTime;
            }
            assessmentDetails.sendAssessmentsCount = assessmentDetails.sendAssessmentsCount + 1;
            if (assessmentDetails.assessmentLinkStatus == 'Expired') {
                let notes = "";
                this.launchActionModal(context, jobMatch, modalType, label, templateUrl, windowTopClass, callbackType, refreshCallback, removeOrRefreshCardCallback, notes);
            }
            else {
                let ctrl = this;
                this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    template: SendAssessmentConfirmResendModal.default,
                    backdrop: 'static',
                    keyboard: false,
                    controller: ['$uibModalInstance', 'assessmentDetails', 'previousStateDateTime', 'closeCallback', 'formalizeActivityPayload', function ($uibModalInstance, assessmentDetails, previousStateDateTime, closeCallback, formalizeActivityPayload) {
                            var vm = this;
                            vm.assessmentDetails = assessmentDetails;
                            vm.label = 'Confirm Re-send';
                            vm.previousStateDateTime = previousStateDateTime;
                            vm.formalizeActivityPayload = formalizeActivityPayload;
                            vm.resendAction = function (resendFlag) {
                                $uibModalInstance.dismiss('cancel');
                                if (resendFlag) {
                                    closeCallback(vm.resendReason, vm.otherReasonNotes);
                                }
                            };
                            vm.receiveFormalizedComment = function (event) {
                                vm.otherReasonNotes = event;
                            };
                            vm.onVoiceTranscript = function (transcript) {
                                if (vm.otherReasonNotes) {
                                    vm.otherReasonNotes += ' ' + transcript;
                                }
                                else {
                                    vm.otherReasonNotes = transcript;
                                }
                            };
                        }],
                    controllerAs: 'resendConfirmationModal',
                    size: 'lg',
                    resolve: {
                        assessmentDetails: () => {
                            return assessmentDetails;
                        },
                        closeCallback: () => {
                            return (reason, otherReasonNotes) => {
                                if (!_.isUndefined(reason)) {
                                    var notes = "";
                                    if (reason != 'Other') {
                                        notes = reason;
                                    }
                                    else if (!_.isUndefined(otherReasonNotes)) {
                                        notes = otherReasonNotes;
                                    }
                                    this.launchActionModal(context, jobMatch, modalType, label, templateUrl, windowTopClass, callbackType, refreshCallback, removeOrRefreshCardCallback, notes);
                                }
                            };
                        },
                        previousStateDateTime: () => {
                            return previousStateDateTime;
                        },
                        formalizeActivityPayload: () => {
                            return actionObject.formalizeActivityPayload;
                        }
                    }
                });
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    launchActionModal(context, jobMatch, modalType, label, templateUrl, windowTopClass, actionObject, callbackType, refreshCallback, removeOrRefreshCardCallback, notes) {
        let workflowStep = "";
        if (modalType == 'PHONE_SCREEN_FEEDBACK' || jobMatch.currentStep == 'Phone Screen') {
            workflowStep = "ps";
        }
        else if (modalType == 'INTERVIEW_FEEDBACK' || jobMatch.currentStep == 'Interview') {
            workflowStep = "in";
        }
        else if (modalType == 'START_SCREENING') {
            workflowStep = "rs";
        }
        if (context === "associateCandidates") {
            $(".modal").addClass("associate-candidate-modal");
        }
        else if (context === "reviewCandidatePull" || context === "uploadResumes") {
            $(".modal").addClass("review-candidate-pull-modal");
        }
        this.$timeout(() => {
            this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: templateUrl,
                backdrop: 'static',
                keyboard: false,
                windowTopClass: windowTopClass,
                controller: ['$uibModalInstance', 'jobMatchId', 'candidateId', 'jobId', 'modalType', 'label', 'primaryRecruiter', 'candidateJobMatch', 'isSharedRequisition', 'corporateCompanyId', 'corporateCompanyName', 'clientOrBUName', 'jobMatchInfo', 'notes', 'workflowStep', 'candidateDetails', 'clientReviewDetails', 'formalizeActivityPayload', function ($uibModalInstance, jobMatchId, candidateId, jobId, modalType, label, primaryRecruiter, candidateJobMatch, isSharedRequisition, corporateCompanyId, corporateCompanyName, clientOrBUName, jobMatchInfo, notes, workflowStep, candidateDetails, clientReviewDetails, formalizeActivityPayload) {
                        var ctrl = this;
                        ctrl.jobMatchId = jobMatchId;
                        ctrl.jobId = jobId;
                        ctrl.jobMatchIdArray = [];
                        ctrl.jobMatchIdArray.push(ctrl.jobMatchId);
                        ctrl.candidateId = candidateId;
                        ctrl.recruiterId = !_.isUndefined(primaryRecruiter) ? primaryRecruiter.id : undefined;
                        ctrl.modalType = modalType;
                        ctrl.candidateJobMatch = candidateJobMatch;
                        ctrl.label = label;
                        ctrl.isSharedRequisition = isSharedRequisition;
                        ctrl.corporateCompanyId = corporateCompanyId;
                        ctrl.corporateCompanyName = corporateCompanyName;
                        ctrl.clientOrBUName = clientOrBUName;
                        ctrl.jobMatchInfo = jobMatchInfo;
                        ctrl.notes = notes;
                        ctrl.workflowStep = workflowStep;
                        ctrl.moveType = 'Forward';
                        ctrl.isRefreshedDone = false;
                        ctrl.candidateDetails = candidateDetails;
                        ctrl.clientReviewDetails = clientReviewDetails;
                        ctrl.formalizeActivityPayload = formalizeActivityPayload;
                        if (ctrl.modalType == 'MOVE_BACKWARD') {
                            ctrl.moveType = 'Backward';
                        }
                        else if (ctrl.modalType == "SKIP_RECRUITER_SCREENING" || ctrl.modalType == "SKIP_TECHNICAL_ASSESSMENT" || ctrl.modalType == "SKIP_VALUE_ASSESSMENT" || ctrl.modalType == "SKIP_PHONE_SCREEN" || ctrl.modalType == "SKIP_INTERVIEW") {
                            ctrl.moveType = 'Skip';
                        }
                        ctrl.assessmentType = 'Technical';
                        ctrl.assessmentSendMode = 'send';
                        if (ctrl.modalType == 'SEND_VALUE_ASSESSMENT' || ctrl.modalType == 'CANCEL_VALUE_ASSESSMENT' || ctrl.modalType == 'RE_SEND_VALUE_ASSESSMENT') {
                            ctrl.assessmentType = 'Value';
                        }
                        if (ctrl.modalType == 'RE_SEND_TECHNICAL_ASSESSMENT' || ctrl.modalType == 'RE_SEND_VALUE_ASSESSMENT') {
                            ctrl.assessmentSendMode = 'resend';
                        }
                        ctrl.scheduleType = 'phoneScreen';
                        if (ctrl.modalType == 'SCHEDULE_INTERVIEW' || ctrl.modalType == 'MODIFY_INTERVIEW' || ctrl.modalType == 'CANCEL_INTERVIEW') {
                            ctrl.scheduleType = 'interview';
                        }
                        ctrl.scheduleMode = 'add';
                        if (ctrl.modalType == 'MODIFY_PHONE_SCREEN' || ctrl.modalType == 'MODIFY_INTERVIEW') {
                            ctrl.scheduleMode = 'edit';
                        }
                        ctrl.feedbackType = 'Screening';
                        if (ctrl.modalType == 'INTERVIEW_FEEDBACK' || ctrl.modalType == 'INTERVIEW_FEEDBACK_FROM_MEETING_POPUP') {
                            ctrl.feedbackType = 'Interview';
                        }
                        else if (ctrl.modalType == 'PHONE_SCREEN_FEEDBACK' || ctrl.modalType == 'PHONE_SCREEN_FEEDBACK_FROM_MEETING_POPUP') {
                            ctrl.feedbackType = 'PhoneScreen';
                        }
                        if (ctrl.modalType == 'COMMUNICATION') {
                            ctrl.communicationType = 'candidate';
                        }
                        else if (ctrl.modalType == 'PEER_COMMUNICATION') {
                            ctrl.communicationType = 'peer';
                        }
                        ctrl.closeModal = () => {
                            if (ctrl.modalType == 'UPLOAD_RESUME' && !ctrl.isRefreshDone) {
                                ctrl.closeModalAndRefresh();
                            }
                            else {
                                $uibModalInstance.close('cancel');
                            }
                        };
                        ctrl.closeModalAndRefresh = () => {
                            $uibModalInstance.close('cancel');
                            ctrl.refreshCallback();
                        };
                        ctrl.saveCallback = () => {
                            if (ctrl.modalType != 'UPDATE_CONTACT') {
                                $uibModalInstance.close('cancel');
                            }
                            ctrl.refreshCallback();
                        };
                        ctrl.refreshCallback = () => {
                            ctrl.isRefreshDone = true;
                            if (context == 'candidateJobMatchCard') {
                                if (callbackType == 'refreshJobMatch') {
                                    removeOrRefreshCardCallback();
                                }
                                else if (callbackType == 'refreshWorkflow') {
                                    refreshCallback();
                                }
                            }
                            else if (context == 'candidateJobMatches') {
                                refreshCallback();
                            }
                            //check
                        };
                    }],
                controllerAs: 'jobMatchIdModal',
                size: 'lg',
                resolve: {
                    jobMatchId: () => {
                        return jobMatch.jobMatchId;
                    },
                    modalType: () => {
                        return modalType;
                    },
                    label: () => {
                        return label;
                    },
                    candidateId: () => {
                        return jobMatch.id;
                    },
                    candidateJobMatch: () => {
                        return jobMatch;
                    },
                    primaryRecruiter: () => {
                        return jobMatch.primaryRecruiter;
                    },
                    jobId: () => {
                        return jobMatch.jobMatchJobId;
                    },
                    isSharedRequisition: () => {
                        return jobMatch.isSharedRequisition;
                    },
                    corporateCompanyId: () => {
                        return jobMatch.corporateCompanyId;
                    },
                    corporateCompanyName: () => {
                        return jobMatch.corporateCompanyName;
                    },
                    clientOrBUName: () => {
                        return jobMatch.clientOrBUName;
                    },
                    jobMatchInfo: () => {
                        return jobMatch;
                    },
                    notes: () => {
                        return notes;
                    },
                    workflowStep: () => {
                        return workflowStep;
                    },
                    candidateDetails: () => {
                        return actionObject.candidateDetails;
                    },
                    clientReviewDetails: () => {
                        return actionObject.clientReviewDetails;
                    },
                    formalizeActivityPayload: () => {
                        return actionObject.formalizeActivityPayload;
                    }
                }
            });
        }, 300);
    }
    _setCandidateInfoInEmailBody(candidate, candidateAdditionalDetails) {
        let candidateInformation = [];
        let candidateInformationList = ['Full Name', 'Phone Number', 'Email', 'Address', 'Current Role', 'Current Company', 'Seeking Job Type', 'Desired Salary/Rate', 'Sponsorship', 'Sponsorship Notes', 'Preferred Work Locations', 'Willing To Relocate', 'Linkedin Url', 'Additional Information'];
        candidateInformationList.map(val => {
            let tempInformation = {};
            tempInformation.id = 'id' + val;
            tempInformation.name = val;
            tempInformation.value = this._setCandidateInformationObject(val, candidate, candidateAdditionalDetails);
            if (tempInformation.value && tempInformation.value != '') {
                candidateInformation.push(tempInformation);
            }
        });
        return candidateInformation;
    }
    _setCandidateInformationObject(val, candidate, candidateAdditionalDetails) {
        let candidateInformation;
        switch (val) {
            case 'Full Name':
                candidateInformation = (candidate.firstName ? (candidate.firstName + " ") : '') + (candidate.lastName ? candidate.lastName : '');
                break;
            case 'Phone Number':
                candidateInformation = candidate.mobilephone;
                break;
            case 'Email':
                candidateInformation = candidate.email;
                break;
            case 'Address':
                let address = '';
                if (candidate.address) {
                    address = address + (candidate.address.address1 ? candidate.address.address1 + ',' : '');
                    address = address + (candidate.address.address2 ? candidate.address.address2 + ',' : '');
                    address = address + (candidate.address.state ? candidate.address.state + ',' : '');
                    address = address + (candidate.address.city ? candidate.address.city.name + ',' : '');
                    address = address + (candidate.address.country ? candidate.address.country + ',' : '');
                    address = address + (candidate.address.zipcode ? candidate.address.zipcode : '');
                }
                candidateInformation = address;
                break;
                // case 'Current Location':
                //     candidateInformation = candidate.currentJobLocation;
                break;
            case 'Current Role':
                candidateInformation = candidate.currentJobTitle;
                break;
            case 'Current Company':
                candidateInformation = candidate.currentJobCompanyName;
                break;
            case 'Seeking Job Type':
                let matchedJobType = '';
                if (candidateAdditionalDetails && candidateAdditionalDetails.requisitionJobType) {
                    if (candidateAdditionalDetails.preferredJobTypeDetails && candidateAdditionalDetails.preferredJobTypeDetails.jobType) {
                        candidateAdditionalDetails.preferredJobTypeDetails.jobType.map(jobType => {
                            if (jobType.jobType == candidateAdditionalDetails.requisitionJobType) {
                                matchedJobType = jobType.jobType;
                            }
                        });
                    }
                }
                candidateInformation = matchedJobType;
                break;
            case 'Desired Salary/Rate':
                let salaryOrRate = '';
                if (candidateAdditionalDetails && candidateAdditionalDetails.preferredJobTypeDetails) {
                    if (candidateAdditionalDetails.requisitionJobType) {
                        if (candidateAdditionalDetails.requisitionJobType === 'FULLTIME' && candidateAdditionalDetails.preferredJobTypeDetails.salary) {
                            salaryOrRate = salaryOrRate + 'Salary: ' + this._setCandidateSalaryOrRate('salary', candidateAdditionalDetails.preferredJobTypeDetails.salary);
                        }
                        else {
                            if (candidateAdditionalDetails.preferredJobTypeDetails.rate) {
                                salaryOrRate = salaryOrRate + 'Rate: ' + this._setCandidateSalaryOrRate('rate', candidateAdditionalDetails.preferredJobTypeDetails.rate);
                            }
                        }
                    }
                    else {
                        if (candidateAdditionalDetails.preferredJobTypeDetails.salary) {
                            salaryOrRate = salaryOrRate + 'Salary: ' + this._setCandidateSalaryOrRate('salary', candidateAdditionalDetails.preferredJobTypeDetails.salary);
                        }
                        if (candidateAdditionalDetails.preferredJobTypeDetails.rate) {
                            salaryOrRate = (salaryOrRate != '' ? salaryOrRate + '; ' : salaryOrRate) + 'Rate: ' + this._setCandidateSalaryOrRate('rate', candidateAdditionalDetails.preferredJobTypeDetails.rate);
                        }
                    }
                }
                candidateInformation = salaryOrRate;
                break;
            case 'Sponsorship':
                candidateInformation = (candidateAdditionalDetails && candidateAdditionalDetails.sponsorships) ? candidateAdditionalDetails.sponsorships.toString() : '';
                break;
            case 'Sponsorship Notes':
                candidateInformation = candidateAdditionalDetails ? candidateAdditionalDetails.sponsorshipsNote : '';
                break;
            case 'Preferred Work Locations':
                candidateInformation = (candidateAdditionalDetails && candidateAdditionalDetails.preferredWorkLocations) ? candidateAdditionalDetails.preferredWorkLocations
                    .map(location => location.name)
                    .join(', ') : '';
                break;
            case 'Willing To Relocate':
                candidateInformation = candidateAdditionalDetails ? candidateAdditionalDetails.willingToRelocate : '';
                break;
            case 'Linkedin Url':
                let linkedinUrl = '';
                if (candidateAdditionalDetails && candidateAdditionalDetails.urls) {
                    candidateAdditionalDetails.urls.map(url => {
                        if (url.urlType == 'LinkedIn') {
                            linkedinUrl = url.urlLink;
                        }
                    });
                }
                candidateInformation = linkedinUrl;
                break;
            case 'Additional Information':
                candidateInformation = candidateAdditionalDetails ? candidateAdditionalDetails.additionalInformation : '';
                break;
            default:
                break;
        }
        // If value is null, undefined, or empty string, assign 'Not Specified'
        if (!candidateInformation || candidateInformation === '') {
            candidateInformation = 'Not Specified';
        }
        return candidateInformation;
    }
    _setCandidateSalaryOrRate(type, salaryOrRate) {
        let salaryOrRateText = '';
        if (salaryOrRate) {
            if (type == 'salary') {
                if (salaryOrRate.salaryType == 'Range') {
                    salaryOrRateText = salaryOrRate.maxSalary + ' to ' + salaryOrRate.minSalary + " " + salaryOrRate.currency + " " + salaryOrRate.salaryDuration.replace(/_+/g, " ").toLowerCase();
                }
                else {
                    salaryOrRateText = salaryOrRate.maxSalary + " " + salaryOrRate.currency + " " + salaryOrRate.salaryDuration.replace(/_+/g, " ").toLowerCase();
                }
            }
            else {
                if (salaryOrRate.rateType == 'Range') {
                    salaryOrRateText = salaryOrRate.maxRate + ' to ' + salaryOrRate.minRate + " " + salaryOrRate.currency + " " + salaryOrRate.rateDuration.replace(/_+/g, " ").toLowerCase();
                }
                else {
                    salaryOrRateText = salaryOrRate.maxRate + " " + salaryOrRate.currency + " " + salaryOrRate.rateDuration.replace(/_+/g, " ").toLowerCase();
                }
            }
        }
        // If value is null, undefined, or empty string, assign 'Not Specified'
        if (salaryOrRateText === null || salaryOrRateText === undefined || salaryOrRateText === '') {
            salaryOrRateText = 'Not Specified';
        }
        return salaryOrRateText;
    }
    openSendOutreachEmailModal(jobMatches, isVendorOnly, companyId, userId, candidateId, clientOrBUId, candidateType, salaryDurationOptions, jobTypeList, candidateName, successCallback) {
        let tm = this;
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardActionsModal.default,
            backdrop: 'static',
            keyboard: false,
            bindToController: true,
            windowTopClass: 'four-dot-five-modal-large',
            controller: ['$uibModalInstance', '$state', 'actionType', 'jobMatches', 'isVendorOnly', 'label', 'companyId', 'userId', 'candidateId', 'clientOrBUId', 'candidateType', 'salaryDurationOptions', 'jobTypeList', 'candidateName',
                function ($uibModalInstance, $state, actionType, jobMatches, isVendorOnly, label, companyId, userId, candidateId, clientOrBUId, candidateType, salaryDurationOptions, jobTypeList, candidateName) {
                    var vm = this;
                    vm.jobMatches = jobMatches;
                    vm.actionType = actionType;
                    vm.isVendorOnly = isVendorOnly;
                    vm.selectAllJobMatches = false;
                    vm.label = label;
                    vm.companyId = companyId;
                    vm.userId = userId;
                    vm.candidateId = candidateId;
                    vm.clientOrBUId = clientOrBUId;
                    vm.candidateType = candidateType;
                    vm.salaryDurationOptions = salaryDurationOptions;
                    vm.jobTypeList = jobTypeList;
                    vm.candidateName = candidateName;
                    vm.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                    vm.saveCallback = () => {
                        $uibModalInstance.close('cancel');
                        successCallback();
                    };
                    vm.cancelCallback = () => {
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'jobMatchIdModal',
            size: 'lg',
            resolve: {
                jobMatches: () => {
                    return jobMatches;
                },
                actionType: () => {
                    return 'SEND_OUTREACH_EMAIL';
                },
                label: () => {
                    return `Send Outreach to Candidate <b>'${candidateName}'</b>`;
                },
                isVendorOnly: () => {
                    return isVendorOnly;
                },
                companyId: () => {
                    return companyId;
                },
                userId: () => {
                    return userId;
                },
                candidateId: () => {
                    return candidateId;
                },
                clientOrBUId: () => {
                    return clientOrBUId;
                },
                candidateType: () => {
                    return candidateType;
                },
                salaryDurationOptions: () => {
                    return salaryDurationOptions;
                },
                jobTypeList: () => {
                    return jobTypeList;
                },
                candidateName: () => {
                    return candidateName;
                }
            }
        });
    }
}
//# sourceMappingURL=jobMatchActionsService.js.map